import { createFileRoute } from "@tanstack/react-router";
import { routeGuards } from "../utils/routeGuards";

export const Route = createFileRoute("/admin")({
  beforeLoad: routeGuards.admin,
});
